module.exports = __webpack_public_path__ + "media/images/talent/lp/feature05-2df6c888769de8caef646770156611bc.png";